import type { HTMLProps, PropsWithChildren, ReactNode } from 'react'
import { useRef } from 'react'

export interface FadeProps extends PropsWithChildren<HTMLProps<HTMLDivElement>> {
  duration: number
  when: boolean
}

export function Fade({ duration, when, children, ...divProps }: FadeProps): ReactNode {
  const fadeRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={fadeRef}
      style={{
        transition: `opacity ${duration}ms`,
        opacity: when ? 1 : 0,
      }}
      aria-hidden={!when}
      {...divProps}
    >
      {children}
    </div>
  )
}
